module.exports = "/_next/static/images/21-1-d8f6fc2109e9d0ade717d025be1c54c0.svg";